
import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.facebook.com/" className="home__social-icon" target='https://web.facebook.com/profile.php?id=100063818870798' >
        <i className="uil uil-facebook"></i>
        </a>

        <a href="https://www.linkedin.com/" className="home__social-icon" target='https://www.linkedin.com/in/sam-o-afolabi-179309241/' >
        <i className="uil uil-linkedin"></i>
        </a>

        <a href="https://www.github.com/" className="home__social-icon" target='https://github.com/SamOluwadamilare300' >
        <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social
